import { Directive, ElementRef, HostListener } from '@angular/core';
import { GA4 } from '../models/ga4.model';



@Directive()
export abstract class SelectDirective<T extends GA4.GA4> {
    abstract track: T;
    constructor(private element: ElementRef, ) {}
    @HostListener('click') onClick() {
        queueMicrotask(() =>
            GA4.track(this.track)
        );
    }
}
